import 'zone.js';
import '@angular/localize/init';
import 'buffer';